export class MultiFileUploadManager {
    private files: File[] = [];
    private existingMaterials: ExistingMaterial[] = [];
    private removedMaterialIds: number[] = [];
    private input: HTMLInputElement;
    private listEl: HTMLElement;

    constructor(inputSelector: string, listSelector: string) {
        this.input = document.querySelector(inputSelector);
        this.listEl = document.querySelector(listSelector);

        this.input.addEventListener("change", () => this.onFilesPicked());
        this.listEl.addEventListener("click", (e) => this.onListClick(e));
    }

    private onFilesPicked() {
        const picked = Array.from(this.input.files ?? []);

        for (const file of picked) {
            const isDuplicate = this.files.some(
                f => f.name === file.name && f.size === file.size && f.lastModified === file.lastModified
            );
            if (!isDuplicate) {
                this.files.push(file);
            }
        }

        this.syncInput();
        this.render();
    }

    private onListClick(e: Event) {
        const target = e.target as HTMLElement;
        const removeBtn = target.closest("[data-remove-index], [data-remove-material-id]") as HTMLElement | null;
        if (!removeBtn) return;

        if (removeBtn.dataset.removeMaterialId !== undefined) {
            const materialId = Number(removeBtn.dataset.removeMaterialId);
            this.removedMaterialIds.push(materialId);
            this.existingMaterials = this.existingMaterials.filter(m => m.id !== materialId);
        } else {
            const index = Number(removeBtn.dataset.removeIndex);
            this.files.splice(index, 1);
        }

        this.syncInput();
        this.render();
    }

    private syncInput() {
        const dt = new DataTransfer();
        for (const file of this.files) {
            dt.items.add(file);
        }
        this.input.files = dt.files;
    }

    private render() {
        const existingHtml = this.existingMaterials.map(material => {
            const s3Id = encodeURIComponent(material.materialLink);
            const fileName = encodeURIComponent(material.fileName);
            const downloadUrl = `/secure/lms/settings/trainings?handler=DownloadMaterial&s3Id=${s3Id}&fileName=${fileName}`;
            return `
            <div class="lms-file-chip">
                <button type="button" class="lms-icon-button" data-remove-material-id="${material.id}" title="Remove file">
                    <i class="fa-solid fa-xmark"></i>
                </button>
                <a class="lms-file-name" href="${downloadUrl}" target="_blank" rel="noopener noreferrer">${material.fileName}</a>
            </div>
        `;
        }).join("");

        const newHtml = this.files.map((file, index) => `
            <div class="lms-file-chip">
                <button type="button" class="lms-icon-button" data-remove-index="${index}" title="Remove file">
                    <i class="fa-solid fa-xmark"></i>
                </button>
                <span class="lms-file-name">${file.name}</span>
            </div>
        `).join("");

        this.listEl.innerHTML = existingHtml + newHtml;
    }

    getFiles(): File[] {
        return this.files;
    }

    getRemovedMaterialIds(): number[] {
        return this.removedMaterialIds;
    }

    setExistingMaterials(materials: ExistingMaterial[]) {
        this.existingMaterials = materials ?? [];
        this.render();
    }

    reset() {
        this.files = [];
        this.existingMaterials = [];
        this.removedMaterialIds = [];
        this.syncInput();
        this.render();
    }
}
export interface ExistingMaterial {
    id: number;
    fileName: string;
    materialLink: string;
}